import { _internal } from '@ey-fso-tax/mfe-sdk';
import { authModule } from '@/auth/auth-module';
import { clientModule } from '@/client/client-module';
import { eventsModule } from '@/events/events-module';

let registered = false;

/**
 * Registers shell services into the SDK registry so MFEs can call
 * `shell.auth.*`, `shell.client.*`, `shell.events.*` etc.
 *
 * NOTE (M1): the `auth` and `client` modules currently expose a subset of the
 * SDK contract (no `getToken` Observable, no client `change/refresh/...`).
 * Full parity is tracked for M3 — see `docs/ROADMAP.md`. We register through
 * `unknown` casts here intentionally; do **not** widen the SDK types to match
 * partial implementations.
 *
 * The `logger` module is registered in `src/telemetry/tracker.ts` instead of
 * here — telemetry starts before MSAL, and an MFE that mounts early should
 * reach a real transport instead of the SDK's console fallback.
 */
export function registerShellSdk(): void {
  if (registered) return;
  registered = true;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _internal.register('auth', authModule as any);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _internal.register('client', clientModule as any);
  _internal.register('events', eventsModule);
}
